<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" style="height: 54px;">
			<div class="router-title-item">
				<a v-if="false" href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span v-if="false" style="position: absolute;">&gt;&ensp;设备管理&ensp;&gt;&ensp;GPS设备</span>
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane label="实时报警" name="first"></el-tab-pane>
						<el-tab-pane label="历史报警" name="second"></el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->

		<AlarmRealTable v-show="activeName == 'first'" ref="alarmRealTable" />
		<AlarmHisTable v-show="activeName == 'second'" ref="alarmHisTable" />

	</div>
</template>

<script>
	import AlarmRealTable from '@/components_outdoor/Alarm/AlarmRealTable';
	import AlarmHisTable from "@/components_outdoor/Alarm/AlarmHisTable";

	export default {
		/*
		 * 组件名
		 */
		name: "DeviceAlarm",
		/**
		 * 引用组件
		 * */
		components: {
			AlarmHisTable,
			AlarmRealTable
		},
		/**
		 * 数据定义
		 * */
		data() {
			return {
				// mini max tree box
				activeName: 'first'
			}
		},
		/**
		 * 方法定义
		 */
		methods: {
			handleClick(tab, event) {
				if(tab.index == 0) {
					//请求1
					this.$refs.alarmRealTable.research();
				} else if(tab.index == 1) {
					//请求2
					this.$refs.alarmHisTable.research();
				}
			}
		},
	}
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>


// WEBPACK FOOTER //
// src/views/system-outdoor/alarm/DeviceAlarm.vue